/**
 * Hilfsfunktionen für die KM-Stand-Historie pro Werkstatt-Kunden-Fahrzeug
 * (Issue #402).
 *
 * Reine, datenbankunabhängige Logik:
 *   • `sortHistorieByDatum`  — chronologische Sortierung (neueste zuerst)
 *   • `findMaxKMStand`       — größter bisher erfasster KM-Stand
 *   • `isRueckläufig`        — true, wenn ein neu erfasster KM-Stand kleiner
 *                              als das bisherige Maximum ist (Plausibilitäts-
 *                              Warnung im UI)
 */

export interface FahrzeugKMHistorieEintrag {
  id: string;
  fahrzeug_id: string;
  km_stand: number;
  erfasst_am: string;
  quelle: string | null;
  notiz: string | null;
}

export function sortHistorieByDatum(
  eintraege: FahrzeugKMHistorieEintrag[],
): FahrzeugKMHistorieEintrag[] {
  return [...eintraege].sort((a, b) => {
    const ta = new Date(a.erfasst_am).getTime();
    const tb = new Date(b.erfasst_am).getTime();
    return tb - ta;
  });
}

export function findMaxKMStand(
  eintraege: FahrzeugKMHistorieEintrag[],
): number {
  if (eintraege.length === 0) return 0;
  return eintraege.reduce(
    (max, e) => (e.km_stand > max ? e.km_stand : max),
    Number.NEGATIVE_INFINITY,
  );
}

export function isRueckläufig(
  neuerKMStand: number,
  bisherigeEintraege: FahrzeugKMHistorieEintrag[],
): boolean {
  if (bisherigeEintraege.length === 0) return false;
  return neuerKMStand < findMaxKMStand(bisherigeEintraege);
}
